// @flow

export function replacePlaceholdersFromJSON (payload: Object, event: Object): Object {
  const payloadString = JSON.stringify(payload)
    .replace(/{{productId}}/g, event.productId || '')
    .replace(/{{productIds}}/g, event.productIds || '')
    .replace(/{{attributeName}}/g, event.name || '')
    .replace(/{{attributeValue}}/g, event.value || '')

  return JSON.parse(payloadString)
}
